<template>
    <the-animations />
</template>